import { Navigate, RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import DeviceDetailsPage from '~features/devices/pages/deviceDetailsPage';
import DevicesPage from '~features/devices/pages/devicesPage';
import ScheduledActionDetailPage from '~features/scheduledActions/pages/scheduledActionDetailPage';

import PreserveSearchNavigate from './components/preserveSearchNavigate';

const DevicesRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Devices,
			children: [
				{
					index: true,
					element: <Navigate to={pagePathSegments.Assigned} replace />,
				},
				{
					path: pagePathSegments.Assigned,
					element: <DevicesPage deviceListType='assigned' />,
				},
				{
					path: pagePathSegments.Unassigned,
					element: <DevicesPage deviceListType='unassigned' />,
				},
				{
					path: ':id',
					children: [
						{
							index: true,
							element: <PreserveSearchNavigate to={pagePathSegments.General} />,
						},
						{
							path: pagePathSegments.General,
							element: <DeviceDetailsPage tab='general' />,
						},
						{
							path: pagePathSegments.OfflineAccess,
							element: <DeviceDetailsPage tab='offline-access' />,
						},
						{
							path: pagePathSegments.Telemetry,
							element: <DeviceDetailsPage tab='telemetry' />,
						},
						{
							path: pagePathSegments.ScheduledActions,
							children: [
								{
									index: true,
									element: <DeviceDetailsPage tab='scheduled-actions' />,
								},
								{
									path: ':scheduledActionId',
									element: <ScheduledActionDetailPage />,
								},
							],
						},
					],
				},
			],
		},
	];
};

export default DevicesRoutes;
